import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class TagsNavigationController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    
    readonly mode: any; //Type to be determined
    readonly searchString: string; // assumed
    static $inject = [];
}

export const wtTagsNavigation: ComponentDefinition = {
    componentId: 'wtTagsNavigation',
    controller: TagsNavigationController,
    template: require('./tagsNavigation.component.html'),
    controllerAs: 'vm',
    bindings: {
        searchString: '<',
        mode: '<'
    }
};
